
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqvImdfN_6b07iA2XnGUmysXjub9Zhvp0DlNlJDakXCjcMeta } from "/codebuild/output/src1405836003/src/src/pages/faq.vue?macro=true";
import { default as menujXKWnMqovosTB_454YfR2Plg78NFOoXvjYOSlm5GKCJrUMeta } from "/codebuild/output/src1405836003/src/src/pages/menu.vue?macro=true";
import { default as indexS3CjJHIK4E62ZkJq3uMLVT1ZqA5T4VLoEK2p_450rKACsMeta } from "/codebuild/output/src1405836003/src/src/pages/index.vue?macro=true";
import { default as contactkUH_45IkCJ2LpzRUvjo7bTaHSIgOH6cGUXPA7fkEHpppQMeta } from "/codebuild/output/src1405836003/src/src/pages/contact.vue?macro=true";
import { default as tutorialpp8B4yOuTIYSIvk4zCxb4dj9gTA83RIZtaKJC8FRqY0Meta } from "/codebuild/output/src1405836003/src/src/pages/tutorial.vue?macro=true";
import { default as agreementfl5WBF_45tHsI59u5WLvt0Qh_45s4eRzWxpccSSdoy_45RtsQMeta } from "/codebuild/output/src1405836003/src/src/pages/agreement.vue?macro=true";
import { default as about_45passSntJ3ZLFkRf7Phs6v8IRBeWpKLpSb9vL7QiQtr7ylNEMeta } from "/codebuild/output/src1405836003/src/src/pages/about-pass.vue?macro=true";
import { default as indexATtRqXh0socprW3SfzI5ohwHh56YQYPOYWvR9ZM_45sGIMeta } from "/codebuild/output/src1405836003/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93TlEVgY8BYtqOi59MArcpvgjeg1SVc4etn5I3m4EbbxoMeta } from "/codebuild/output/src1405836003/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceOQnJUZKjlVmeWFZHDVUGR1ycSlYI_TDpy_45QdtGOsZJsMeta } from "/codebuild/output/src1405836003/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93SV_TTRFFbYMhXdaHkbxjPwo09_jFVPnVay7_45sR1cr3YMeta } from "/codebuild/output/src1405836003/src/src/pages/notice/[id].vue?macro=true";
import { default as indexKDfUXJTOqmNB65kfbcPuymMFrXTKtZsVH8BBIwLFoy8Meta } from "/codebuild/output/src1405836003/src/src/pages/coupon/index.vue?macro=true";
import { default as indexixpc5BUZUn3n7eZXc1tNpd_45O089FlpjXjluoOogi_eUMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/index.vue?macro=true";
import { default as indexY9eNUnMwuBTRS5iILOvqtE8NoVgcMZV2cNA8u6fncCwMeta } from "/codebuild/output/src1405836003/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93x28L8MKdBFWcwiAlKGLbk6Qj46Hp6Qru_45WnLtplwHd4Meta } from "/codebuild/output/src1405836003/src/src/pages/parking/[id].vue?macro=true";
import { default as index3aVXhHJnAWRbFQvFSyoxxOjUCysYbkebssvhSZEnkicMeta } from "/codebuild/output/src1405836003/src/src/pages/history/index.vue?macro=true";
import { default as indexBB0xJnNPGDjTDxGxS30t_zpGOZfodtvAIKL637MulNMMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/index.vue?macro=true";
import { default as indexoiGd_451zxR83ycYBdTlxLXMI1601YDI_foL3PXFXbucwMeta } from "/codebuild/output/src1405836003/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexmHrYFq5OCJvGzeqRTDAGfka1x278h3vKakyGkD_45DfFEMeta } from "/codebuild/output/src1405836003/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavinStypLFOAdxjSG4Zh0K46YZvYh6_JSVZOoYg_45M55wJ0Meta } from "/codebuild/output/src1405836003/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editdyTco23sDJvxRzJCM49zAcbdcQ75Ag9FIvDMJyCPWdUMeta } from "/codebuild/output/src1405836003/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementfXDoWd7P0aADVhw9USp6or1TaEkqTj4AksNaf5eHoEoMeta } from "/codebuild/output/src1405836003/src/src/pages/pass-agreement.vue?macro=true";
import { default as index27cg2auw9OKytW1fR2yq_S3FQYslW_45iIj01TBDUkxGQMeta } from "/codebuild/output/src1405836003/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453duEmwhY1IqIFbaiDbinDP5StTKOj9RvxJBvL6kaF2H3EMeta } from "/codebuild/output/src1405836003/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmPmRXCvgVPH4I9wzEsD1rSGRsMCBHb9qyVySdDaETFWwMeta } from "/codebuild/output/src1405836003/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexxY860RqAGFa9BhEjkVvBvKaU2Q6q4fe_45UK7L7iMWAMUMeta } from "/codebuild/output/src1405836003/src/src/pages/card/create/index.vue?macro=true";
import { default as index1GsaD0cdP2t8aKt0DsrtKQtbtlf6F_45aRdOT_vbMiMNAMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmMnFxO4VuYbC_WHV_45yfWAzLPO6G3op4E8hA80yPrsdn4Meta } from "/codebuild/output/src1405836003/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmxE5cH15upFUhQw9ap0TN0_45C80NNemQ3mltDh6j_45z_icMeta } from "/codebuild/output/src1405836003/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeSXDV3H04bhixkeXko_Ur99eXtOUCsQ28b_45avZN5XOMQMeta } from "/codebuild/output/src1405836003/src/src/pages/membership/complete.vue?macro=true";
import { default as registerUxRECXTGDt2VcePm8eyUtPrFFrpQI_45ev_B4G_lRVx7IMeta } from "/codebuild/output/src1405836003/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93RTC15BHT_133hf_zSaZEqF8Kt0hinrM7QP9OqruLk_4Meta } from "/codebuild/output/src1405836003/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmNR6FBujBpXbm93x_Cps7jiQB0U_r5Uj6Up6p2CNf51IMeta } from "/codebuild/output/src1405836003/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93DuMT1qWSVcgaZXYqoMZnDTG0UcFJ8Lle5r_4576jwid5EMeta } from "/codebuild/output/src1405836003/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexys_45u2H4xb4iYGKHO9jSj1zIsxuCjbXon7wlBR0a7SNwMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeAo882zao_Bu__45_452GUTKyfk23HJKGiNo9oDK82PMNzYMMeta } from "/codebuild/output/src1405836003/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeOLcVTIjJdosUj3OXXkmKdKQW5DT6CaoxjX5SFHVq1hcMeta } from "/codebuild/output/src1405836003/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete1JH7v7l4c5E2oGhp0XvsfGfUboNcMvBKHODADf0_459GEMeta } from "/codebuild/output/src1405836003/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register1jRsVYRqFD64d5chJB_45tW2iPxV_45o_459kKssjiHEvcsFUMeta } from "/codebuild/output/src1405836003/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeCyEEqGDEb_0QVo1ZmwcITKUt0bii1tdGyFFmmyDOfgwMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexx0z8HOXsSFB9u3sUjgtIuH_45PiCDdLXhlOyiMxK06IOcMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmBbq5MsJj7sYTC45Eb1Z2SO5ILiY9iXnKQsbpBA8DlEUMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completen_45eAk4W8qjeezpg7bvLBxH5ZAkLH4_vBQ8yH4PEuDvgMeta } from "/codebuild/output/src1405836003/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index_45fowgdYBXIX8neJMx0MX2mWLa8Tc7GBvSGazJp9V6HUMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93EmVZHEqH8Wx_xWIiod9AFiuQpWb644BGpqOOFZEw_rkMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeGsYEBjFEQ31J4COE66RmFvrKcroD1CeYrnA9mumkVukMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasLmVeI79pYXu_RObBBH7CG5G_R1XdmJ5tAwaQM1qo4NEMeta } from "/codebuild/output/src1405836003/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleRzaJCLgjHprRmRsrmkzbKGth2pj1BzW5cAlaaHYysDQMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailmsQJXNukH9zetqkaGb5WL_453IcxBDZ6ofaaFl3yiAIC0Meta } from "/codebuild/output/src1405836003/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm17fp6oOLSQ5vANTwqE8Zq_dQI6eNsMVQ8h70jH6UiTcMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentVW7c4nbsNgYx_45UtU3oytBZtEkve1O8wtqxQvgffGkGAMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmJ4tdMx7kO935XEIxCLkN4jcW6mtcczIVQB2U0BLuIFsMeta } from "/codebuild/output/src1405836003/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate7rRjW_TjIipjEUI_EjXUtjR3BiyWzcuRkRCCzRML6PgMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete7diArMN7Ap_fIpXccgUnHddb8fsST8yTo1wh0Vr7Vf8Meta } from "/codebuild/output/src1405836003/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeaILP75Rr8lShQwMEOD70HZOiUwdQe_K0VbQ7_45eu8GY8Meta } from "/codebuild/output/src1405836003/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordkJ5BpuJdCLhD_45MN5e55b5W_45JlMgcBPTU7TfWgGA0nxgMeta } from "/codebuild/output/src1405836003/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasWofyWCXf0eHDrzB5VdeHhkniwJsEhbWzihJjjTzxLtkMeta } from "/codebuild/output/src1405836003/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerJwPguxxXKyR2Y_457KCaXBbERPsu51JBIZkqAx83yRaQkMeta } from "/codebuild/output/src1405836003/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codePGeonnaZnpgn23emHJ6mN072b8qeI_lyPlwCdAebDKoMeta } from "/codebuild/output/src1405836003/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index7pZoLR023W3NG8Z2OsHZ_MHpbxUo0_Bs3ZxLdAXuBXsMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexcaZvYhVWQpCN2T_i6eDXaduhHWDZVpyD_OszGIWGsagMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index1V0iXXulcw8RtmeSgSKoOcfkMz7_Ds7KianbY3Rwy_45wMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexwJw5K3k6DdthEjLMhysD9AXAfgj3bkcCZW9w7NWJ7rEMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatefh3gLtNAaf408TuePJwGway9eUVkw2LhspMkc8gNmnEMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeDPVqBpOlVc5JPA60jTwqNo5978BouTGQbwCgOs72ECoMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmR6fCOgrDAPQKRNyQY7ht35dnAanXgJl6yt5rJnvG8xQMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexqc_Kwz_5B7BvQzuiqZVlftSqijjpFW7SIn6CJCGGk_45kMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete_45cqoaDG_Wks_u0CsrDnivlNQVtL_pb00_hJ_45BcpP0wwMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update6pQ4NeBBAg4D2ilgevJ__45DFaiKvxYpvw0Kc9TMwSu0IMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexc19pFMFxs6rSXvw2MJmBRA2SEvF1sbi6IX6dzYU7D8MMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexRK3YFlZlzWM_45XH_VUwiAjELDnUT0QERVt7w0W6dtdWEMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completekpPQhNPsZROUllqDiLLWiAjAzkmIojFlTkBSTNIqYioMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexBRPP1LqFkQOW3lhh9XthMxzka0_45_45biMMVYO8aj_hQtgMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code0_vMJ6rbu8EiSAIINbH0n9EcHpRP_45rtF_45MgS4HNV_MgMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexOxNuItFSkGsMkhuMEXuVEFeuHt1pqeaoOhwMy9JioewMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexPApvLXsscN0mUAAgjsuyqAkbnl0sfT4D9v6gwaSs8SsMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexvYrNfcILZn8ak8bRedNQvy_45PLN4SIT8EL3ZU1_5JT0UMeta } from "/codebuild/output/src1405836003/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatePl0bvipRXOBVpiUmi5_45aBnLShevvP8UqZ6kuQtrrIbIMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmLpEVIteJg5tqKUoiwZz2CzF6Jg0AbG9jzsF8viWO_45qIMeta } from "/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menujXKWnMqovosTB_454YfR2Plg78NFOoXvjYOSlm5GKCJrUMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexS3CjJHIK4E62ZkJq3uMLVT1ZqA5T4VLoEK2p_450rKACsMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexKDfUXJTOqmNB65kfbcPuymMFrXTKtZsVH8BBIwLFoy8Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index3aVXhHJnAWRbFQvFSyoxxOjUCysYbkebssvhSZEnkicMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexoiGd_451zxR83ycYBdTlxLXMI1601YDI_foL3PXFXbucwMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexmHrYFq5OCJvGzeqRTDAGfka1x278h3vKakyGkD_45DfFEMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexxY860RqAGFa9BhEjkVvBvKaU2Q6q4fe_45UK7L7iMWAMUMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmMnFxO4VuYbC_WHV_45yfWAzLPO6G3op4E8hA80yPrsdn4Meta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmxE5cH15upFUhQw9ap0TN0_45C80NNemQ3mltDh6j_45z_icMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeSXDV3H04bhixkeXko_Ur99eXtOUCsQ28b_45avZN5XOMQMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerUxRECXTGDt2VcePm8eyUtPrFFrpQI_45ev_B4G_lRVx7IMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmNR6FBujBpXbm93x_Cps7jiQB0U_r5Uj6Up6p2CNf51IMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeAo882zao_Bu__45_452GUTKyfk23HJKGiNo9oDK82PMNzYMMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeOLcVTIjJdosUj3OXXkmKdKQW5DT6CaoxjX5SFHVq1hcMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete1JH7v7l4c5E2oGhp0XvsfGfUboNcMvBKHODADf0_459GEMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register1jRsVYRqFD64d5chJB_45tW2iPxV_45o_459kKssjiHEvcsFUMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmBbq5MsJj7sYTC45Eb1Z2SO5ILiY9iXnKQsbpBA8DlEUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completen_45eAk4W8qjeezpg7bvLBxH5ZAkLH4_vBQ8yH4PEuDvgMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index_45fowgdYBXIX8neJMx0MX2mWLa8Tc7GBvSGazJp9V6HUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeGsYEBjFEQ31J4COE66RmFvrKcroD1CeYrnA9mumkVukMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleRzaJCLgjHprRmRsrmkzbKGth2pj1BzW5cAlaaHYysDQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailmsQJXNukH9zetqkaGb5WL_453IcxBDZ6ofaaFl3yiAIC0Meta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm17fp6oOLSQ5vANTwqE8Zq_dQI6eNsMVQ8h70jH6UiTcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentVW7c4nbsNgYx_45UtU3oytBZtEkve1O8wtqxQvgffGkGAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmJ4tdMx7kO935XEIxCLkN4jcW6mtcczIVQB2U0BLuIFsMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete7diArMN7Ap_fIpXccgUnHddb8fsST8yTo1wh0Vr7Vf8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeaILP75Rr8lShQwMEOD70HZOiUwdQe_K0VbQ7_45eu8GY8Meta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordkJ5BpuJdCLhD_45MN5e55b5W_45JlMgcBPTU7TfWgGA0nxgMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerJwPguxxXKyR2Y_457KCaXBbERPsu51JBIZkqAx83yRaQkMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codePGeonnaZnpgn23emHJ6mN072b8qeI_lyPlwCdAebDKoMeta || {},
    component: () => import("/codebuild/output/src1405836003/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1405836003/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]